module.exports = __webpack_public_path__ + "content/09054737ea976302592937775d0530f4.png";